import React from 'react'
import {Col} from 'react-bootstrap'
import DashboardSingleClientDetailsContainer from './upper-presentation'
import TabsLoader from './tabs-container/loader'
import CompanyDetails from './tabs-container/details-container'
import CompanyRoles from './tabs-container/roles-container'
import CompanyShareholders from './tabs-container/shareholders-container'
import ClientSales from './tabs-container/sales-container'
import { useSelector } from 'react-redux'
import TabSelector from '../../../library/tab-selector'
import { UpperRow } from '../../../library/upper-row'
import './style.scss'

const Index = () => {

	const clientDetails = useSelector(state => state.singleClient.details)
	const loading = useSelector(state => state.singleClient.fetchDetails.loading)

	const companyTabs = [
		{
			key: "details",
			title: "Detaljer",
			content: <CompanyDetails/>
		},
		{
			key: "roles",
			title: "Roller",
			content: <CompanyRoles/>
		},
		{
			key: "shareholders",
			title: "Aksjonærer",
			content: <CompanyShareholders/>
		},
		{
			key: "sales",
			title: "Salg",
			content: <ClientSales/>
		}
	]

	const personTabs = [
		{
			key: "sales",
			title: "Salg",
			content: <ClientSales/>
		}
	]

	const loadingTabs = [
		{
			key: "loading",
			title: "Laster inn",
			content: <TabsLoader/>
		}
	]


	const LoadingView = () => {
		return(
			<TabSelector defaultValue="loading" items={loadingTabs}/>
		)
	}

	const renderSelections = () => {
		if(!loading && clientDetails.type === "company"){
			return(
				<TabSelector defaultValue="details" items={companyTabs}/>
			)
		} else if(!loading && clientDetails.type === "person"){
			return(
				<TabSelector defaultValue="sales" items={personTabs}/>
			)
		}
	}

	return(
		<Col md={7} className="dashboard-single-client-left-container">
			<Col className="inner-dashboard-single-client-left-container">
				<UpperRow title="Informasjon"/>
				<DashboardSingleClientDetailsContainer/>
				{loading ? <LoadingView/>:renderSelections()}
			</Col>
		</Col>
	)
}

export default Index